export default __webpack_public_path__ + "src/_images/Guard_SameDayVanIcon.png";